
// get elements to updated its inner HTML
const dataPanelWrapper = document.querySelector(`[data-today="dataWrapper"]`),
    curHourWrapper = dataPanelWrapper.querySelector(`[data-today="hour"]`),
    curDateWrapper = dataPanelWrapper.querySelector(`[data-today="date"]`);

// change data every 1 sec
window.setInterval(() => {
    setCurrentDate(curHourWrapper, curDateWrapper);

}, 1000)

getWeather();


/**
 * updates and insert current date and hour
 * @param {HTMLElement} curHourWrapper - element for updated data
 * @param {HTMLElement} curDateWrapper - element for updated data
 */
setCurrentDate = (curHourWrapper, curDateWrapper) => {
    const curDate = new Date(),
        day = (curDate.getDate() < 10 ? '0' : '') + curDate.getDate(),
        month = ((curDate.getMonth() + 1) < 10 ? '0' : '') + (curDate.getMonth() + 1),
        year = curDate.getFullYear(),
        hour = (curDate.getHours() < 10 ? '0' : '') + curDate.getHours(),
        minute = (curDate.getMinutes() < 10 ? '0' : '') + curDate.getMinutes(),
        // second = ((curDate.getSeconds() + 1) < 10 ? '0' : '') + (curDate.getSeconds() + 1),
        todaysDate = `${day}.${month}.${year}`,
        curHour = `${hour}:${minute}`;

    // insert collected data into its wrapper
    curHourWrapper.innerHTML = curHour;
    curDateWrapper.innerHTML = todaysDate;
}

function getWeather(lat, long) {
    const root = "https://api.openweathermap.org/data/2.5/weather?lat=52.213046&lon=21.019616&units=metric&appid=8eb24903bcfdf8525a15d85289074eaf";
    fetch(`${root}&lat=${lat}&lon=${long}`, { method: "get" })
        .then(resp => resp.json())
        .then(data => {
            setCurrentTemp(data)
        })
        .catch(function (err) {
            console.error(err);
        });
}

/**
 * sets current temperature using data from API OpenWheather
  * @param {JSON} data - information from external API
 */
setCurrentTemp = (data) => {
    const curTempWrapper = dataPanelWrapper.querySelector(`[data-today="temp"]`),
        currentTemp = Math.round(data.main.temp)

    curTempWrapper.innerHTML = `${currentTemp}<sup>o</sup>C`;

}